<div class="top">
  <div class="title" matDialogTitle>
    <h3>Select an icon</h3>
    <div class="configurations-row">
      <mat-form-field class="filter">
        <mat-label>Filter</mat-label>
        <input
          matInput
          [ngModel]="filterSubject.value"
          (ngModelChange)="filterSubject.next($event)"
          />
      </mat-form-field>
      <mat-button-toggle-group class="font-set" [(ngModel)]="fontSet">
        @for (fontSet of fontSets | keyvalue; track fontSet) {
          <mat-button-toggle
            [value]="fontSet.key"
            >{{ fontSet.value }}</mat-button-toggle
            >
          }
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="content" matDialogContent>
      @if (icons$ | async; as icons) {
        <div>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title
                >{{
                filterSubject.value.trim() ? 'Exact matches' : 'All icons'
                }}
                ({{ icons.exact.size }})</mat-panel-title
                >
              </mat-expansion-panel-header>
              <div class="icon-grid">
                @for (iconName of icons.exact; track iconName) {
                  <div
                    class="icon"
                    (click)="onSelect(iconName)"
                    matDialogClose
                    >
                    <mat-icon [fontSet]="fontSet">{{ iconName }}</mat-icon>
                    <span class="icon-name">{{ iconName }}</span>
                  </div>
                }
              </div>
            </mat-expansion-panel>
            @if (filterSubject.value.trim()) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title
                    >Approximate matches ({{ icons.approximate.size }})</mat-panel-title
                    >
                  </mat-expansion-panel-header>
                  <div class="icon-grid">
                    @for (iconName of icons.approximate; track iconName) {
                      <div
                        class="icon"
                        (click)="onSelect(iconName)"
                        matDialogClose
                        >
                        <mat-icon [fontSet]="fontSet">{{ iconName }}</mat-icon>
                        <span class="icon-name">{{ iconName }}</span>
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              }
            </div>
          } @else {
            <mat-spinner class="loading"></mat-spinner>
          }

        </div>
      </div>
